module.exports = __webpack_public_path__ + "static/laser_xl-ef0bba71d2eaec7c762596ab5e018b11.webp";